import React, { useState } from 'react';
import api from '../utils/api';

export function ActGenerator() {
  const [guideShortName, setGuideShortName] = useState('');
  const [periodId, setPeriodId] = useState('1');
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    if (!guideShortName) {
      alert('Введите сокращение экскурсовода');
      return;
    }

    setLoading(true);
    try {
      const response = await api.generateAct({
        periodId: parseInt(periodId),
        guideShortName: guideShortName
      });
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `act-${guideShortName}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        const error = await response.json();
        alert('Ошибка при генерации акта: ' + (error.message || 'Неизвестная ошибка'));
      }
    } catch (error) {
      console.error('Error generating act:', error);
      alert('Ошибка при генерации акта');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>📄 Генерация актов</h1>
      
      <div style={{
        background: 'white',
        padding: '30px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        maxWidth: '500px'
      }}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Экскурсовод (сокращение):
          </label>
          <input
            type="text"
            value={guideShortName}
            onChange={(e) => setGuideShortName(e.target.value)}
            placeholder="Например: Авдеев В.Ю."
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ced4da',
              borderRadius: '6px',
              fontSize: '14px'
            }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Период:
          </label>
          <select
            value={periodId}
            onChange={(e) => setPeriodId(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ced4da',
              borderRadius: '6px',
              fontSize: '14px'
            }}
          >
            <option value="1">Май 2026</option>
          </select>
        </div>

        <button
          onClick={handleGenerate}
          disabled={loading || !guideShortName}
          style={{
            width: '100%',
            padding: '12px',
            background: loading ? '#6c757d' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: '16px'
          }}
        >
          {loading ? '⏳ Генерация...' : '📄 Сгенерировать акт'}
        </button>
      </div>
    </div>
  );
}
